var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuriteIncendie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_714_4099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0142 2L15.1029 5.43792C12.829 7.02961 10.4203 8.41933 7.90423 9.59119L3 11.8754V15.7245C3 18.0714 3.21292 20.4135 3.63613 22.7219L3.75827 23.3881C4.12443 25.3854 4.68131 27.3429 5.42124 29.2339L5.54303 29.5451C6.14677 31.088 6.88626 32.5743 7.75279 33.9864V33.9864C9.02082 36.0528 10.5519 37.9458 12.3075 39.6178L12.5599 39.8582C13.9569 41.1887 15.4763 42.3844 17.0979 43.4294L20.0142 45.3088",
    stroke: "#A3AED0",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1333 2L25.0446 5.43792C27.3184 7.02961 29.7272 8.41933 32.2432 9.59119L37.1475 11.8754V16.9635C37.1475 18.4869 37.0281 20.008 36.7905 21.5127V21.5127M20.1333 45.3088L22.037 44.119",
    stroke: "#A3AED0",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3881 36.2665L27.7479 46.9747L24.0691 45.5032C23.3563 45.2181 22.7088 44.7911 22.1659 44.2482C21.61 43.6924 21.1758 43.027 20.8909 42.2943L20.7787 42.0056C20.5869 41.5125 20.4505 40.9996 20.372 40.4764L20.3204 40.1321C20.1962 39.3043 20.1906 38.463 20.3037 37.6337C20.4272 36.7277 20.691 35.8465 21.0855 35.0217L21.2729 34.6297C21.6226 33.8985 22.048 33.2061 22.5422 32.5637L24.1785 30.4365C25.4342 28.4744 26.2736 26.2753 26.6445 23.9755L26.6771 23.7736C27.6184 25.4994 28.1869 27.4036 28.3458 29.363L28.4618 30.7934L29.4726 29.1285C30.139 28.031 30.5554 26.8001 30.6922 25.5234C30.791 24.6007 30.7406 23.66 30.5461 22.7527C30.2721 21.4738 29.716 20.2599 28.9225 19.2202L26.6771 16.2778L28.6113 16.685C30.3224 17.0453 31.9562 17.706 33.4367 18.6366C34.7131 19.439 35.8595 20.4318 36.836 21.5805L36.9602 21.7267C38.5647 23.6144 39.6538 25.885 40.1217 28.3179C40.4367 29.9557 40.464 31.6359 40.2026 33.2831L39.408 38.2892L43.0963 30.7934L43.9969 33.3824C44.6565 35.279 44.8648 37.3033 44.6051 39.2944L44.469 40.3381C44.3482 41.264 44.0533 42.1588 43.5997 42.9751L43.5061 43.1436C43.2343 43.633 42.8955 44.082 42.4997 44.4779C41.874 45.1036 41.1181 45.5838 40.2858 45.8843L37.2663 46.9747L32.3881 36.2665Z",
    stroke: "#A3AED0",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_714_4099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuriteIncendie);
export default __webpack_public_path__ + "static/media/SecuriteIncendie.3900f1695a361014003bf4e34c62efd7.svg";
export { ForwardRef as ReactComponent };